import React from "react";
import { Target, Compass } from "lucide-react";
import { PageHero, PageBody, STATIC_CONTENT, renderInstituteHtml } from "./_shared";
import { useFood } from "./FoodLayout";

export default function VisionMission() {
  const data = useFood();
  const inst = data.institute || {};
  const vision = (inst.vision || "").trim() || STATIC_CONTENT.vision;
  const mission = (inst.mission || "").trim() || STATIC_CONTENT.mission;
  return (
    <div data-testid="ft-vision-mission">
      <PageHero eyebrow="Direction" title="Vision &amp; Mission" />
      <PageBody>
        <div className="grid md:grid-cols-2 gap-8">
          <div className="bg-gradient-to-br from-[#1F6B3F] to-[#13532E] rounded-xl p-8 text-white shadow-xl relative overflow-hidden">
            <div className="absolute -top-10 -right-10 w-40 h-40 bg-[#F4751F]/20 rounded-full blur-3xl" />
            <div className="relative">
              <div className="w-12 h-12 bg-[#F4751F] rounded-md flex items-center justify-center text-white mb-4">
                <Target size={22} strokeWidth={2} />
              </div>
              <h2 className="font-serif text-3xl mb-3">Our Vision</h2>
              <div className="text-white/90 italic leading-relaxed font-serif text-lg prose prose-invert prose-sm max-w-none" data-testid="ft-vision-text" dangerouslySetInnerHTML={{ __html: renderInstituteHtml(vision) }} />
            </div>
          </div>
          <div className="bg-gradient-to-br from-[#F4751F] to-[#C95507] rounded-xl p-8 text-white shadow-xl relative overflow-hidden">
            <div className="absolute -bottom-10 -left-10 w-40 h-40 bg-[#1F6B3F]/20 rounded-full blur-3xl" />
            <div className="relative">
              <div className="w-12 h-12 bg-white rounded-md flex items-center justify-center text-[#C95507] mb-4">
                <Compass size={22} strokeWidth={2} />
              </div>
              <h2 className="font-serif text-3xl mb-3">Our Mission</h2>
              <div className="text-white/95 italic leading-relaxed font-serif text-lg prose prose-invert prose-sm max-w-none" data-testid="ft-mission-text" dangerouslySetInnerHTML={{ __html: renderInstituteHtml(mission) }} />
            </div>
          </div>
        </div>
      </PageBody>
    </div>
  );
}
